export default function unauthorized() {
  return (
    <div style={{ textAlign: "center", marginTop: "5rem" }}>
      <h1>Acceso denegado</h1>
      <p>No tienes permisos para acceder a esta sección.</p>
    </div>
  );
}
